export default __webpack_public_path__ + "static/media/mail1.74a8750b.svg";